'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H4 from 'UIComponents/elements/headings/H4';
import UIButton from 'UIComponents/button/UIButton';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import { Scopes } from 'AdsUI/lib/Scopes';
import ScopeWrapper from 'AdsUI/components/ScopeWrapper';

const CreateAudienceButton = ({
  onOpenAudiencePanel,
  isInDropdown = false,
  enableTour,
  closeAudienceShepherd
}) => /*#__PURE__*/_jsx(UIPopover, {
  use: "shepherd",
  open: enableTour,
  width: 350,
  content: {
    header: /*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "tours.createAudience.header"
      })
    }),
    body: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "tours.createAudience.body"
    }),
    footer: /*#__PURE__*/_jsx(UIButton, {
      use: "primary",
      onClick: closeAudienceShepherd,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "tours.createAudience.footer"
      })
    })
  },
  children: /*#__PURE__*/_jsx(ScopeWrapper, {
    tooltipKey: "createAudiences",
    orScopes: [Scopes.ADS_DEMO_ACCESS, Scopes.ADS_WRITE],
    children: /*#__PURE__*/_jsx(UIButton, {
      use: "secondary",
      onClick: onOpenAudiencePanel,
      "data-test-id": "create-audience-button",
      size: "small",
      className: isInDropdown ? '' : 'm-left-2',
      children: isInDropdown ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createDropdown.audience"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createAudienceButton"
      })
    })
  })
});

CreateAudienceButton.propTypes = {
  onOpenAudiencePanel: PropTypes.func.isRequired,
  isInDropdown: PropTypes.bool,
  enableTour: PropTypes.bool,
  closeAudienceShepherd: PropTypes.func.isRequired
};
export default CreateAudienceButton;